import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { Anchor } from '@/components/ui/anchor';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AppRoutes } from '@/enums/app-routes';
import { useSharedState, useUpdateSharedState } from '@/hooks/state/shared-state';
import Image from 'next/image';
import { NewRegistrationContent } from './new-registration-content';

export const MfaDialog = (): React.JSX.Element => {
  const { data: sharedState } = useSharedState();
  const { mutate: updateSharedState } = useUpdateSharedState();
  const isNewRegistration = sharedState?.showMfaModal === 'isNewRegistration';
  const mfaProviderUrl = `/membership/mfa-select-provider?mfa=enable&returnUrl=${AppRoutes.ACCOUNT_PROFILE}`;

  const open = Boolean(sharedState?.showMfaModal);

  const handleOpenChange = (nextOpen: boolean): void => {
    if (!nextOpen) {
      updateSharedState({ showMfaModal: null });
    }
  };

  return (
    <Dialog open={open}
      onOpenChange={handleOpenChange}
    >
      <DialogContent className="max-w-[400px] flex flex-col text-on-surface"
        onInteractOutside={(e) => {e.preventDefault();}}
      >
        <DialogHeader showCloseButton={true}>
          <DialogTitle className="text-xl font-bold"
            data-test="mfa-modal-title"
          >Enable two-factor authentication
          </DialogTitle>
        </DialogHeader>
        {!isNewRegistration &&
          <Image alt="Enable two-factor authentication for additional account security."
            className="self-center mx-auto"
            height={165}
            loading="eager"
            src="/img/mfa-enable.png"
            width={323}
          />
        }
        <div className="flex flex-col gap-md">
          <small data-test="mfa-description-security">
            Add a layer of security to your account.
            {' '}<CinemarkLink primary
              useAnchor
              dataLinkCategory="MFA Modal"
              dataLinkName="Learn More"
              dataTest="mfa-learn-more"
              disableAutoTracking={false}
              href="/membership/mfaenable"
            >Learn More
            </CinemarkLink>
          </small>
          <DialogClose asChild>
            <Anchor className="w-full"
              data-test="button-enable-mfa"
              dataLinkCategory="MFA Modal"
              dataLinkName="Enable Two-Factor Authentication"
              href={mfaProviderUrl}
            >
              Yes, Enable 2FA
            </Anchor>
          </DialogClose>
        </div>
        {isNewRegistration &&
            <NewRegistrationContent />
        }
        <DialogClose asChild>
          <Button className="w-full"
            data-test="button-continue-shopping"
            variant="outline"
          >
            Continue Shopping
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
